import React, { useReducer } from 'react';
import App from './components/App';
import reducer, { model } from './reducer';
import { qsParse } from '../utils/qs';

const Share = () => {
  const params = qsParse(window.location.search);
  const [state, dispatch] = useReducer(reducer, model());
  return <App params={params} state={state} dispatch={dispatch} />;
};

export default Share;
